module.exports = __webpack_public_path__ + "img/wenlv.629f7568.png";